import { Instagram, Facebook, Phone, Mail } from "lucide-react";
import { SITE } from "../lib/api";

export default function Footer() {
  return (
    <footer className="relative bg-[#050505] border-t border-white/10 overflow-hidden" data-testid="site-footer">
      <div className="absolute -bottom-40 left-1/2 -translate-x-1/2 w-[800px] h-[400px] rounded-full bg-[#3B82F6]/12 blur-[140px] pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 py-20">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-white p-1">
                <img src={SITE.logo} alt="Anton Pears" className="w-full h-full object-contain rounded-full" />
              </div>
              <div>
                <div className="font-display text-2xl tracking-wider">ANTON PEARS</div>
                <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-500">DJ · Charente 16</div>
              </div>
            </div>
            <p className="text-sm text-zinc-400 mt-6 leading-relaxed max-w-md">
              French DJ — Professionnel & Déclaré. Mariages, soirées privées, festivals & événements professionnels en Nouvelle-Aquitaine.
            </p>
            <div className="mt-6 flex gap-3">
              <a href={SITE.social.instagram} target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full border border-white/10 hover:border-[#3B82F6] hover:text-[#3B82F6] flex items-center justify-center transition-all" aria-label="Instagram">
                <Instagram size={16} />
              </a>
              <a href={SITE.social.facebook} target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full border border-white/10 hover:border-[#3B82F6] hover:text-[#3B82F6] flex items-center justify-center transition-all" aria-label="Facebook">
                <Facebook size={16} />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.3em] text-[#3B82F6]">Navigation</div>
            <ul className="mt-5 space-y-3 text-sm text-zinc-300">
              <li><a href="#hero" className="hover:text-[#3B82F6] transition-colors">Accueil</a></li>
              <li><a href="#prestations" className="hover:text-[#3B82F6] transition-colors">Prestations</a></li>
              <li><a href="#disponibilites" className="hover:text-[#3B82F6] transition-colors">Disponibilités</a></li>
              <li><a href="#galerie" className="hover:text-[#3B82F6] transition-colors">Galerie</a></li>
              <li><a href="#contact" className="hover:text-[#3B82F6] transition-colors">Contact</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs uppercase tracking-[0.3em] text-[#3B82F6]">Coordonnées</div>
            <ul className="mt-5 space-y-3 text-sm text-zinc-300">
              <li><a href={`tel:${SITE.phoneIntl}`} className="inline-flex items-center gap-2 hover:text-[#3B82F6]"><Phone size={14} /> {SITE.phone}</a></li>
              <li><a href={`mailto:${SITE.email}`} className="inline-flex items-center gap-2 hover:text-[#3B82F6] break-all"><Mail size={14} /> {SITE.email}</a></li>
              <li className="text-zinc-500">Zones : 16 · 17 · 79 · 86 · Limitrophe Charente</li>
            </ul>
          </div>
        </div>

        {/* Big text logo */}
        <div className="relative mt-20 mb-6">
          <div className="font-display text-[18vw] md:text-[14vw] leading-none tracking-tighter text-center bg-clip-text text-transparent bg-gradient-to-b from-white/8 to-transparent select-none">
            ANTON PEARS
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-3 pt-8 border-t border-white/10">
          <div className="text-xs text-zinc-500">© {new Date().getFullYear()} Anton Pears DJ — Tous droits réservés.</div>
          <div className="text-xs text-zinc-500">SIRET déclaré · Nouvelle-Aquitaine, France</div>
        </div>
      </div>
    </footer>
  );
}
